import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_IMG, PRODUCT_NAME, CHECKOUT_URL } from './constants';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const Unit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="text-center" data-id="element-153" data-mp="32kcbv43samei">
      <div className="bg-brand-ink text-white text-xl sm:text-2xl font-bold px-3 py-1.5 rounded-lg shadow-inner font-mono" data-id="element-154" data-mp="32ldm56cz74v6">
        {String(value).padStart(2, '0')}
      </div>
      <p className="text-[10px] font-bold text-brand-slate mt-1 tracking-wider" data-id="element-155" data-mp="2sv2fvd5tkjl4">
        {label}
      </p>
    </div>;
  return <section id="pricing" className="py-8 px-4 bg-brand-cloud border-y border-brand-gold/30 scroll-mt-4" data-id="element-156" data-mp="2xsaz7h2petny">
      <div className="max-w-2xl mx-auto" data-id="element-157" data-mp="2jsji37gw4x5q">
        <div className="text-center mb-4" data-id="element-158" data-mp="2otgwd8ys571y">
          <p className="text-sm font-extrabold text-brand-blue uppercase tracking-widest mb-1" data-id="element-159" data-mp="2ouih655ll7wv">
            Special Offer — Complete 6-in-1 System
          </p>
          <p className="text-base font-bold text-brand-ink mb-3" data-id="element-160" data-mp="2etydywyiptc0">
            Get instant access today and completely transform the way you plan
            and coach gymnastics.
          </p>
          <div className="inline-block bg-brand-navy text-white px-4 py-1.5 rounded-lg shadow-md mb-4" data-id="element-161" data-mp="d3wox639sjnf">
            <p className="font-bold text-sm sm:text-base tracking-wide font-display" data-id="element-162" data-mp="bmhlg7y4co16">
              🤸 {PRODUCT_NAME} — Complete 6-in-1 Planning System
            </p>
          </div>
          <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-163" data-mp="1ns02570klg6">
            <img src={PRODUCT_IMG} alt="Gymnastics Coach Pro 6-in-1 System" className="w-full max-w-xs mx-auto object-contain drop-shadow-xl mb-4 hover:scale-[1.02] transition-transform duration-300" data-id="element-164" data-mp="1q4h8g4y6rs6" />
          </a>
        </div>

        <div className="bg-white border-4 border-brand-gold rounded-2xl p-4 sm:p-6 text-center relative mb-4 shadow-2xl" data-id="element-165" data-mp="pe5w06spz4g1">
          <div className="mb-4" data-id="element-166" data-mp="kkjhe92zwqhl">
            <p className="text-sm sm:text-base font-bold text-brand-slate mb-1" data-id="element-167" data-mp="glu7wrl2vt38">
              Regular Price: <span className="line-through" data-id="element-168" data-mp="1d3qi2yk66htj">$97</span>
            </p>
            <p className="text-lg sm:text-xl font-extrabold text-brand-blue mb-2 uppercase tracking-wide" data-id="element-169" data-mp="1d51luydm7pkn">
              🔥 72% OFF — Limited-Time Launch Offer
            </p>
            <p className="text-5xl sm:text-6xl font-display font-extrabold text-brand-ink mb-1" data-id="element-170" data-mp="2r12wl28u571x">
              $27 USD
            </p>
            <p className="text-xs sm:text-sm font-bold text-brand-slate uppercase tracking-wider" data-id="element-171" data-mp="2zzwr8n2lvncu">
              Today Only • Pay securely in your local currency.
            </p>
          </div>

          <div className="bg-brand-blue/5 border border-brand-blue/20 rounded-xl p-3 mb-5" data-id="element-172" data-mp="39y416lyh955c">
            <p className="text-sm font-bold text-brand-navy mb-2 uppercase tracking-wide" data-id="element-173" data-mp="39w9ply93ipdx">
              🔥 Last Chance! This special price expires when the countdown
              reaches zero.
            </p>
            <div className="flex justify-center items-start gap-3" data-id="element-174" data-mp="3np9725sfuto4">
              <Unit value={timeLeft.hours} label="HOURS" data-id="element-175" data-mp="3nrlmab6tapxh" />
              <div className="text-xl font-bold text-brand-slate mt-1.5" data-id="element-176" data-mp="3spn4ktweyl7w">:</div>
              <Unit value={timeLeft.minutes} label="MINUTES" data-id="element-177" data-mp="1hretorrsvqm" />
              <div className="text-xl font-bold text-brand-slate mt-1.5" data-id="element-178" data-mp="1g6lg2h6ziuc">:</div>
              <Unit value={timeLeft.seconds} label="SECONDS" data-id="element-179" data-mp="3jzdh9355zefr" />
            </div>
          </div>

          <CTAButton href={CHECKOUT_URL} className="!bg-brand-gold !text-brand-ink border-brand-ink/20 shadow-[0_4px_14px_0_rgba(212,166,42,0.39)] hover:!bg-brand-gold/90" data-id="element-180" data-mp="3f1bxsh3ttd3r">
            🚀 YES! I WANT MY COMPLETE 6-IN-1 SYSTEM
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-5 gap-y-1 text-sm text-brand-ink font-bold" data-id="element-181" data-mp="312m0p1h0bdfe">
          <div className="flex items-center gap-1.5" data-id="element-182" data-mp="2w53pt5jfio4r">
            <StarIcon className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-183" data-mp="3b0jm7h7hew4b" />
            <span data-id="element-184" data-mp="361gfztfrmjur">4.9/5 — Verified Coach Reviews</span>
          </div>
          <span className="hidden sm:inline text-brand-line" data-id="element-185" data-mp="3639s3o95dwa5">•</span>
          <div className="flex items-center gap-1.5" data-id="element-186" data-mp="q8pv9yyq7509">
            <ShieldCheckIcon className="w-4 h-4 text-brand-blue" data-id="element-187" data-mp="lb7wv2ic486i" />
            <span data-id="element-188" data-mp="laoan9lnixmo">7-Day Money-Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}